<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid fullWidth>
      <cv-row>
        <cv-column :sm="4" :md="3" :lg="8">
          <cv-text-input label="Descrizione" title="Descrizione"
                         value="Fusignano" />
        </cv-column>
        <cv-column :sm="3" :md="3" :lg="6">
          <cv-combo-box label="Seleziona" title="Unità di misura"
                        value="Ettari (HA)" :auto-filter="true"
                        :options="options_um"></cv-combo-box>
        </cv-column>
        <cv-column :sm="1" :md="2" :lg="2">
          <cv-text-input label="Estensione" title="Estensione"
                         value="0" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="8">
          <cv-combo-box label="Seleziona un comune" title="Comune"
                        :auto-filter="true"
                        @change="cambiamento"
                        v-model="modello_comune"
                        :options="comuni"/>
        </cv-column>
        <cv-column :sm="2" :md="3" :lg="3">
          <cv-text-input label="Latitudine" title="Latitudine"
                         value="37.421925" />
        </cv-column>
        <cv-column :sm="2" :md="3" :lg="3">
          <cv-text-input label="Longitudine" title="Longitudine"
                         value="-122.0841293" />
        </cv-column>
        <cv-column :sm="4" :md="2" :lg="2">
          <cv-text-input label="Raggio" title="Raggio"
                         value="30" />
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <Bottoniera testo_nuovo="Nuovo Fondo"
                testo_salva="Salva Fondo"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" />

  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {
  name: "Fondi",
  components: { Bottoniera },
  data: function() {
    return {
      modello_comune: "Ferrara",
      options_um: [
        {
          value: "1",
          label: "Ettari (HA)",
          name: "Ettari (HA)"
        },
        {
          value: "2",
          label: "Ore",
          name: "Ore"
        }
      ],
      comuni: [
        {
          value: "1",
          label: "Ravenna",
          name: "1",
        },
        {
          value: "2",
          label: "Ferrara",
          name: "2",
        },
        {
          value: "3",
          label: "Forlì",
          name: "3",
        }
      ]
    }
  },
  methods: {
    cambiamento: function (evento) {
      console.log(evento);
    }
  }
}
</script>

<style scoped>

</style>